/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IGym } from '../domains/Gym';
import { IPaginatedResponse } from '../domains/Pagination';
import { api } from './api';

interface IAdminUserMembership {
  id: string;
  user_id: string;
  gym_id: string;
  gym: IGym;
  status: string;
  permissions: string[];
  created_at: string;
}

interface IAdminUser {
  id: string;
  fullname: string;
  nickname: string;
  username: string;
  email: string;
  phone?: string;
  birthday?: string;
  avatar_url?: string;
  is_active: boolean;
  created_at: string;
  memberships: IAdminUserMembership[];
  platformPermissions: string[];
}

interface IGetAdminUsersParams {
  page?: number;
  limit?: number;
  search?: string;
  permission_codes?: string[];
}

interface IAssociateUserParams {
  email: string;
  gym_id: string;
  permission_codes: string[];
}

interface IAssociateUserResponse {
  id: string;
  user_id: string;
  gym_id: string;
}

class AdminUsersService {
  private apiService = api;

  public async getUsers(params: IGetAdminUsersParams = {}) {
    return this.apiService.get<IPaginatedResponse<IAdminUser>>(
      'users/admin/users',
      { params },
    );
  }

  public async getUser(user_id: string) {
    return this.apiService.get<IAdminUser>(`users/admin/users/${user_id}`);
  }

  public async setActiveStatus(user_id: string, is_active: boolean) {
    return this.apiService.patch(`users/admin/users/${user_id}/active-status`, {
      is_active,
    });
  }

  public async associateUser(data: IAssociateUserParams) {
    return this.apiService.post<IAssociateUserResponse>(
      'users/admin/gym-users',
      data,
    );
  }

  public async updatePermissions(
    gym_user_id: string,
    permission_codes: string[],
  ) {
    return this.apiService.put(`users/admin/gym-users/${gym_user_id}`, {
      permission_codes,
    });
  }

  public async removeMembership(gym_user_id: string) {
    return this.apiService.delete(`users/admin/gym-users/${gym_user_id}`);
  }

  // Escopo `platform` -- replace completo, separado do CRUD de vínculo
  // (gym-users) de propósito, mesmo motivo documentado no server
  // (UpdateUserPlatformPermissionsService).
  public async updatePlatformPermissions(
    user_id: string,
    permission_codes: string[],
  ) {
    return this.apiService.put(`users/platform-permissions/${user_id}`, {
      permissions: permission_codes,
    });
  }
}

export { AdminUsersService };
export type { IAdminUser, IAdminUserMembership };
